const LATEX_REPLACEMENTS = {
  "\\": String.raw`\textbackslash{}`,
  "&": String.raw`\&`,
  "%": String.raw`\%`,
  "$": String.raw`\$`,
  "#": String.raw`\#`,
  "_": String.raw`\_`,
  "{": String.raw`\{`,
  "}": String.raw`\}`,
  "~": String.raw`\textasciitilde{}`,
  "^": String.raw`\textasciicircum{}`,
};

export const escapeLatex = (value) =>
  String(value ?? "")
    .replace(/[\\&%$#_{}~^]/g, (character) => LATEX_REPLACEMENTS[character])
    .replace(/[\r\n]+/g, " ");

export const buildLatexDocument = ({
  blocks,
  mode,
  anchor,
  multiplier,
  targetSize,
  gaugeStitches,
  gaugeRows,
  mainStitchPattern,
}) => {
  const isGarment = mode === "garment";
  const title = isGarment ? "AmiGuru Garment Draft" : "AmiGuru Amigurumi Draft";
  const metadata = isGarment
    ? `Target size: ${targetSize}; gauge: ${gaugeStitches} stitches and ${gaugeRows} rows per 4 inches; main stitch: ${mainStitchPattern}`
    : `Anchor: ${anchor} stitches; scale multiplier: ${multiplier}`;

  const sections = blocks.map((block) => {
    const safeName = block.component_name_latex || escapeLatex(block.component_name);
    return String.raw`
\section*{${safeName}}
\begin{longtable}{@{}p{0.12\textwidth}p{0.36\textwidth}p{0.42\textwidth}@{}}
\textbf{Step} & \textbf{Compact instruction} & \textbf{Beginner explanation} \\
\hline
${block.latex}
\end{longtable}`;
  }).join("\n");

  return String.raw`\documentclass[11pt]{article}
\usepackage[T1]{fontenc}
\usepackage[margin=0.75in]{geometry}
\usepackage{longtable}
\usepackage{xcolor}
\setlength{\parindent}{0pt}
\setlength{\LTpre}{0.4em}
\setlength{\LTpost}{1.2em}

\begin{document}
\begin{center}
{\LARGE\textbf{${escapeLatex(title)}}}\\[0.4em]
${escapeLatex(metadata)}
\end{center}

\noindent\colorbox{yellow!15}{\parbox{0.96\textwidth}{\textbf{Drafting notice:} This AI-assisted pattern is a starting point. Check gauge, stitch counts, shaping, and fit before committing to the full project.}}
${sections}

\end{document}
`;
};
